import { AuthInterceptor, DEFAULT_TIMEOUT } from './auth-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
  [ { provide: DEFAULT_TIMEOUT, useValue: 120000 } ]
]